var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaypal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 36"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 36,
  fill: "#0071C0",
  rx: 6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#99C6E5",
  d: "M30.619 13.204q-.027.174-.062.356c-.798 4.104-3.528 5.521-7.015 5.521h-1.776a.86.86 0 0 0-.852.732l-.909 5.774-.257 1.637a.455.455 0 0 0 .448.526h3.15c.372 0 .689-.271.747-.64l.031-.16.593-3.769.038-.206a.76.76 0 0 1 .749-.641h.47c3.051 0 5.44-1.241 6.138-4.831.291-1.5.14-2.752-.631-3.633a3 3 0 0 0-.862-.666"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCE2F2",
  d: "M29.784 12.87a6 6 0 0 0-.776-.172 10 10 0 0 0-1.565-.114H22.7a.757.757 0 0 0-.748.641l-1.009 6.401-.029.187a.86.86 0 0 1 .852-.732h1.776c3.487 0 6.217-1.417 7.015-5.521q.035-.182.062-.356a4.3 4.3 0 0 0-.835-.333"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.952 13.225a.76.76 0 0 1 .748-.641h4.743a10 10 0 0 1 1.565.114q.205.033.4.076a6 6 0 0 1 .555.153q.353.117.656.277c.237-1.516-.001-2.549-.82-3.484-.903-1.03-2.532-1.47-4.616-1.47h-6.051a.865.865 0 0 0-.855.732l-2.52 16.003a.52.52 0 0 0 .512.602h3.736l.938-5.96z"
})));
export default SvgPaypal;